import { Row, Col } from 'antd'

export const Footer = () => {


        return (
                <div id="footer">
                        <div className="container">
                        <Row gutter={15}>

                                <Col sm={24}>
                                        <h2>Want to speak about something?</h2>
                                        <p>
                                                John is always open to conversations around Podcasts, speaking opportunities or investing and building ideas into businesses.
                                        </p>
                                        <h3>John@Geater.co.uk</h3>
                                </Col>
                                
                                <Col sm={24}>
                                        <div className="logo">
                                                JOHN GEATER
                                        </div>
                                </Col>
                        </Row>
                        </div>
                </div>
        )
}